import { createReducer } from '@reduxjs/toolkit';
import {
  saveContractSuccessAction,
  saveContractErrorAction,
  validateContractSuccessAction,
  validateContractErrorMessageAction,
  validateContractErrorMessageRowAction,
  clearContractAction,
  getContractForDateError,
  setContract,
  confirmContractError,
  validateContractErrorMessageExtraInfoAction,
} from 'store/actions/contract-actions';
import IContractState from 'types/contract/IContractState';

const initialState: IContractState = {
  saveContractSuccess: false,
  saveContractError: false,
  validateContractSuccess: false,
  validateContractsSuccess: false,
  validateContractErrorMessage: '',
  validateContractExtraMessage: '',
  validateContractErrorMessageRow: null,
  wage: '',
  contract: null,
  getContractForDateError: false,
  confirmContractError: false,
};

const contractReducer = createReducer(initialState, builder => {
  return builder
    .addCase(saveContractSuccessAction, (state, action) => ({ ...state, saveContractSuccess: action.payload }))
    .addCase(saveContractErrorAction, (state, action) => ({ ...state, saveContractError: action.payload }))
    .addCase(validateContractSuccessAction, (state, action) => ({ ...state, validateContractSuccess: action.payload }))
    .addCase(validateContractErrorMessageAction, (state, action) => ({
      ...state,
      validateContractErrorMessage: action.payload,
    }))
    .addCase(validateContractErrorMessageExtraInfoAction, (state, action) => ({
      ...state,
      validateContractExtraMessage: action.payload,
    }))
    .addCase(validateContractErrorMessageRowAction, (state, action) => ({
      ...state,
      validateContractErrorMessageRow: action.payload,
    }))
    .addCase(clearContractAction, state => ({
      ...state,
      saveContractSuccess: false,
      saveContractError: false,
      contract: null,
      validateContractSuccess: false,
      validateContractErrorMessage: '',
      validateContractExtraMessage: '',
      wage: '',
    }))
    .addCase(getContractForDateError, (state, action) => ({ ...state, getContractForDateError: action.payload }))
    .addCase(setContract, (state, action) => {
      return {
        ...state,
        contract: action.payload,
      };
    })
    .addCase(confirmContractError, (state, action) => ({
      ...state,
      confirmContractError: action.payload,
    }));
});

export default contractReducer;
